import React from 'react'
import PropTypes from 'prop-types'
import { MdArrowBack } from 'react-icons/md'
import { Formik, Form as FormikForm } from 'formik'
import * as Yup from 'yup'
import * as transform from '../../../lib/transform'
import Button from '../../commons/Button/Button'
import Text from '../../commons/Text/Text'
import TextFieldFormik from '../../commons/Fields/TextFieldFormik'

export const PHONE_FIELD_ID = 'PHONE_FIELD_ID'

export const INITIAL_VALUES = {
  phoneNumberCell: ''
}

export const VALIDATION_MESSAGES = {
  phoneNumberCell: {
    required: 'Telefone requerido'
  }
}

export const PhoneSchema = {
  phoneNumberCell: Yup.string().required(
    VALIDATION_MESSAGES.phoneNumberCell.required
  )
}

export const RegisterPhoneSchema = Yup.object().shape({
  ...PhoneSchema
})

const RegisterPhoneForm = (props) => {
  const { handleSubmit, initialValues, back } = props

  const newInitialValues = {
    ...INITIAL_VALUES,
    ...initialValues
  }

  return (
    <Formik
      enableReinitialize
      initialValues={newInitialValues}
      validationSchema={RegisterPhoneSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid }) => {
        const disabled = isSubmitting || !isValid

        return (
          <FormikForm>
            <TextFieldFormik
              name="phoneNumberCell"
              validate="phone"
              mask="phone"
              label="Digite seu telefone"
              transform={transform.toNumber}
            />

            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Button
                type="outlined_dark"
                margin="12px 24px 0px 0px"
                buttonType="button"
                width="160px"
                onClick={back}
              >
                <MdArrowBack size={18} />
                <Text
                  font="custom"
                  color="gray"
                  variation="dark"
                  size="xs"
                  value="Voltar"
                  margin="0px 0px 0px 13px"
                  bold
                />
              </Button>
              <Button
                type="secondary"
                margin="12px 0 0"
                buttonType="submit"
                disabled={disabled}
                width="160px"
              >
                <Text
                  font="custom"
                  color="white"
                  size="xs"
                  value="Confirmar"
                  bold
                />
              </Button>
            </div>
          </FormikForm>
        )
      }}
    </Formik>
  )
}

RegisterPhoneForm.defaultProps = {
  handleSubmit: null,
  initialValues: {},
  back: null
}

RegisterPhoneForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.shape({
    phoneNumberCell: PropTypes.string
  }),
  back: PropTypes.func
}

export default RegisterPhoneForm
